<div
  class="absolute"
  #menuTrigger="matMenuTrigger"
  [matMenuTriggerFor]="contextMenu"
  [style.left.px]="state.model.position.x"
  [style.top.px]="state.model.position.y"
></div>

<mat-menu #contextMenu="matMenu">
  <button mat-menu-item *ngFor="let item of state.model.items; trackBy: trackByLabel" (click)="item.callback()">
    <fa-icon *ngIf="item.icon" [icon]="$any(item.icon)"></fa-icon>
    {{ item.label }}
  </button>
</mat-menu>
